import type { VenueRoom as GQLVenueRoom } from '@/generated/graphql';
import { take } from '@/helpers/takePayload';

export interface VenueRoom {
  id?: number;
  name?: string;
}

export const getNew = (): VenueRoom => ({
  id: null,
  name: '',
});

export const fromGql = (gqlVenueRoom: GQLVenueRoom): VenueRoom => ({
  ...(take(gqlVenueRoom, 'id', 'name') as VenueRoom),
});
